import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import MainStore from '../../../MainStore';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';

export default class AuthTypeSelect extends Component {

    constructor(props) {
        super(props);

        this.state = {
            products: [],
            isOpen: false,
            name: !!props.name ? props.name : '',
            id: !!props.id ? props.id : '',
            isChanged: false,
            isProductSaving: false
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadProducts = this.loadProducts.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.name !== this.props.name) {
            this.setState({ name: this.props.name });
        }
    }

    handleInputChange(e) {
        this.setState({ name: e.target.value, id: '', isChanged: true });
        this.loadProducts(e.target.value);
    }

    loadProducts(v) {
        var scope = this;

        fetchWithAuth(
            'api/Server/GetAuthTypes?name=' + v,
            null
            ,
            'application/json',
            (result) => {
                this.setState({ products: result });
                MainStore.setMaskUnvisible();
            },
            'GET'
        );
    }

    handleClear() {
        this.setState({ name: '', id: '', isOpen: false });
        this.props.handleSelect({ name: '', id: '' });
    }

    handleOpen(e) {
        this.setState({ isOpen: true });
        this.loadProducts('');
    }

    handleBlur(e) {
        this.setState({ isOpen: false });
    }

    render() {

        var products = this.state.products.map(p => <MenuItem onMouseDown={e => { this.setState({ name: p.name, id: p.id, isOpen: false, isChanged: false }); this.props.handleSelect({ name: p.name, id: p.id }); }} value={p.id}>{p.name}</MenuItem>);
        return (
            <div>
                <FormControl>
                    <InputLabel htmlFor="project-required">{this.props.label}</InputLabel>
                    <Input required
                        id="project-required"
                        type='text'
                        label={this.props.label}
                        fullWidth
                        margin="none"
                        value={this.state.name}
                        onChange={this.handleInputChange}
                        onFocus={this.handleOpen}
                        onBlur={this.handleBlur}
                        autoComplete='off'
                        disabled={!!this.props.disabled}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={this.handleClear}
                                    size="large">
                                    x
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
                {this.state.isOpen &&
                    <div className="project-dropdown-list">
                        {products}
                    </div>
                }
            </div>
        );
    }
}
